import React from 'react';
import './index.css';

export function Text(props) {
  return (
    <span 
      style={{
        display: props.block ? 'block' : null,
        color: props.white ? '#ffffff' :
               props.orange ? '#ff4f00' :
               props.color ? props.color : 
               '#243746',
        fontSize: props.huge ? 32 :
                  props.large ? 20 :
                  props.small ? 12 : 
                  props.size ? props.size : 
                  16,
        lineHeight: '1.2em',
        fontFamily: props.bold ? 'MontserratBold' :
                    props.semibold ? 'MontserratSemiBold' :
                    props.light ? 'Montserrat' :
                    'MontserratSemiBold',
        ...props.style
      }}
      className={`text ${props.className}`}>
      {props.children}
    </span>
  );
}

export function Title({className, ...props}) {
  return (
    <Text 
      large
      className={`title ${className}`}
      {...props}
    />
  );
}